import { Typography } from '@mui/material';
import { DialogHeader } from '../../../shared/dialog';

import { styles } from './styles';

export const AudienceSelectionDialogHeader = () => {
  return (
    <DialogHeader>
      <Typography sx={styles.heading}>Audience</Typography>
      <Typography sx={styles.subheading}>Who can see your post?</Typography>
    </DialogHeader>
  );
};
